<template>
    <div id="services-page">
        <div class="page-heading hide-on-small">
            <h2 class="display-4 montserrat-bold mb-0">Experts</h2>
            <div class="mt--2 heading-small">Shop's available services experts</div>
        </div>
    
        <div class="search-bar-container">
            <i class="fas fa-search icon"></i> 
            <input type="text" placeholder="Search" class="search-bar" v-model="expertParams.search" @keyup.enter="$refs.list.refresh()">
        </div>

        <div class="bg-white shadow-reg list-container">
            <div class="list-wrapper">
                <paginated-section v-if="expertsFetchLink" :fetch-link="expertsFetchLink" :params="expertParams" paginate-path="data.result.experts" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading experts
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No experts were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <expert-list-item :expert="record" />
                    </template>
                </paginated-section>
            </div>
        </div>

        <!-- <service-modal ref="serviceModal" /> -->

    </div>
</template> 
<script>
import '@styles/table.css';
import ExpertListItem from "./ExpertListItem";
// import ServiceModal from "./ServiceModal";
import { route } from "@utils/network";

export default {
    name: "ExpertsPage",

    components: { ExpertListItem },

    data: () => ({
        loading: false,
        shop: {},
        expertsFetchLink: null,
        expertParams: {
            shop_id: null,
            search: "",
        },
    }),

    methods: {
        initialize(shop) {
            this.shop = shop;
            this.expertParams.shop_id = shop.id;
            this.expertsFetchLink = route("shops/experts");

        },
        showService(service) {
            // return this.$refs.serviceModal.show(service);
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>